const translations = {
    actionsLabel: 'Aircraft actions',
    delete: 'Delete',
    deleteError: 'Aircraft could not be deleted.',
    deleteSuccess: 'Aircraft deleted.',
    edit: 'Edit',
    emptyDescription: 'Add an aircraft to see it listed here.',
    emptyHeading: 'No aircraft yet',
    flightControllerSerial: 'Flight Controller Serial',
    loadError: 'Aircraft could not be loaded.',
    loadMore: 'Load more',
    make: 'Make',
    model: 'Model',
    name: 'Name',
    registrationNumber: 'Registration Number',
    serialNumber: 'Serial Number',
    swathWidth: 'Swath Width (m)',
    tableLabel: 'Aircraft'
};

export default translations;
